const STORAGE_KEY = 'dcmweb_view_state'

function readBlob () {
  try {
    const raw = localStorage.getItem(STORAGE_KEY)
    if (!raw) return {}
    const parsed = JSON.parse(raw)
    return parsed && typeof parsed === 'object' ? parsed : {}
  } catch (e) {
    return {}
  }
}

function writeBlob (blob) {
  try {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(blob))
  } catch (e) {
    // QuotaExceeded or private mode — fail silently
  }
}

/**
 * Load persisted view state for a given view key and user login.
 * @param {string} view
 * @param {string|null|undefined} login
 * @returns {object}
 */
export function loadViewState (view, login) {
  if (!view || !login) return {}
  const blob = readBlob()
  const userState = blob[login]
  if (!userState || typeof userState !== 'object') return {}
  const viewState = userState[view]
  return viewState && typeof viewState === 'object' ? { ...viewState } : {}
}

/**
 * Shallow-merge a patch into the persisted view state for a user/view.
 * @param {string} view
 * @param {string|null|undefined} login
 * @param {object} patch
 */
export function saveViewState (view, login, patch) {
  if (!view || !login || !patch || typeof patch !== 'object') return
  const blob = readBlob()
  const userState = blob[login] && typeof blob[login] === 'object' ? { ...blob[login] } : {}
  const prev = userState[view] && typeof userState[view] === 'object' ? { ...userState[view] } : {}
  userState[view] = { ...prev, ...patch }
  writeBlob({ ...blob, [login]: userState })
}

/**
 * Clear persisted view state for a user/view.
 * @param {string} view
 * @param {string|null|undefined} login
 */
export function clearViewState (view, login) {
  if (!view || !login) return
  const blob = readBlob()
  const userState = blob[login]
  if (!userState || typeof userState !== 'object') return
  const nextUserState = { ...userState }
  delete nextUserState[view]
  if (Object.keys(nextUserState).length === 0) {
    const nextBlob = { ...blob }
    delete nextBlob[login]
    writeBlob(nextBlob)
  } else {
    writeBlob({ ...blob, [login]: nextUserState })
  }
}

export const VIEW_KEYS = {
  managerReports: 'managerReports',
  editTasks: 'editTasks',
  summary: 'summary'
}
